import axiosInstance, { axiosInstanceCached, axiosInstanceV3 } from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

// @ {
// @ 	"id": "3eaef7a7-7592-45b4-9896-30175a5f9424", Round ID
// @ }
export const matchGet = async (payload) => {
  let response = {};
  try {
    // response = await axiosInstanceV3.post(`/match_get`, payload);
    response = await axiosInstance.post(`/v3/match_get`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ {
// @ 	"player_id": "3eaef7a7-7592-45b4-9896-30175a5f9424", Guest User ID
// @ }
export const matchGetByPlayer = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/match_get_by_player`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
